const Footer = () => {
    return (
        <footer className="d-flex justify-content-center py-3">
            <p className="text-center">&copy; 2021</p>
        </footer>
    );
};

export default Footer;